module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy.1e2a6bd4.png";